module.exports = __webpack_public_path__ + "img/verification-zalo.9e979da.webp";